import { Box, Button, Grid, Typography, } from "@mui/material";
import Table, { ExtendedColumnType } from "components/Table";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { ResType } from "types";
import { createGstrPromiseClient, getGstrRecords } from "api/services/clients/gstr-clients";
import { snack } from "components/toast";
import React from "react";
import { CLIENT_CATEGORIES, RegularTaxHeadings, SortDirection } from "data/constants";
import { getGstFinancialYears } from "utils/FinancialYears";
import { useSelector } from "react-redux";
import { selectGstRegister } from "redux/reducers/gstRegisterSlice";
import PeriodSelect from "views/register/GstReturns/YearmonthPeriodSelect";
import AppliedFilters from "views/register/ApplidedFilters";
import sortHandler from "components/Table/SortHandler";
import { usePermissions } from "context/PermissionsProvider";
import { Permissions } from "data/permissons";
import SyncAtomPro from "views/tasks/board/SyncAtomPro";


function IffTask() {
    const financialYears = getGstFinancialYears();
    const { permissions } = usePermissions();
    const [selected, setSelected] = useState<any[]>([]);
    const currentMonth = new Date().getMonth();
    const adjustedMonthIndex = currentMonth === 0 ? 12 : currentMonth;
    const reqMonth = adjustedMonthIndex < 10 ? `0${adjustedMonthIndex}` : `${adjustedMonthIndex}`;
    const [selectedYear, setSelectedYear] = React.useState(financialYears[0]);
    const [selectedMonth, setSelectedMonth] = React.useState(reqMonth);
    const [page, setPage] = useState<number>(0);
    const [pageCount, setPageCount] = useState<number>(10);
    const [filters, setFilters] = useState({
        labels: [],
        search: "",
    });
    const [tableData, setTableData] = useState<any[]>([]);
    const [lodd, setLoad] = useState<boolean>(false);
    const queryClient = useQueryClient();
    const states = useSelector(selectGstRegister);
    const [sort, setSort] = useState<any>({});

    useEffect(() => {
        setSelected([]);
    }, [selectedYear, selectedMonth]);

    const monthLydefaultColumns: Array<ExtendedColumnType> = [
        {
            key: 'client.clientId', title: "Client ID",
            // sort: true,
            // active: false,
            // direction: SortDirection.ASC, default: true, 
            render: (row: any) => row?.client ? row?.client?.clientId : row?.clientGroup?.clientId
        },
        {
            key: "category",
            title: "Category",
            // sort: true,
            // active: false,
            // direction: SortDirection.ASC, default: true,
            render: (rowData) => {
                return (
                    <>
                        {CLIENT_CATEGORIES.map((item: any) => {
                            return item.value == rowData?.client?.category ? item.label : "";
                        })}
                    </>
                );
            },
        },
        {
            key: "client.gstNumber", title: "GSTIN", default: true, render: (row: any) => row?.client ? row?.client?.gstNumber : row?.clientGroup?.gstNumber
        },
        {
            key: "client.displayName", title: "Client Name",
            //  sort: true,
            // active: false,
            // direction: SortDirection.ASC, default: true,
            render: (row: any) => row?.client ? row?.client?.displayName : row?.clientGroup?.displayName,
        },
        {
            key: "status", title: "Return Status", sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
            render: (row: any) => row?.returnsData?.[0]?.status === 'Filed' ? <Typography color='green'>{row?.returnsData?.[0]?.status} </Typography>
                : (row?.returnsData?.[0]?.status === 'NA') ? (<Typography color='red'>{row?.returnsData?.[0]?.status} </Typography>) : <Typography color='red'>Not Filed</Typography>
        },
        {
            key: "dof", title: "Date of Filing", sort: true,
            active: false,
            direction: SortDirection.ASC, default: true,
            render: (row: any) => row?.returnsData?.[0]?.dof ? row?.returnsData?.[0]?.dof : "-"
        },
        {
            key: "arn", title: "ARN", default: true,
            render: (row: any) => row?.returnsData?.[0]?.arn ? row?.returnsData?.[0]?.arn : "-"
        },
    ]


    const { data, isLoading }: ResType = useQuery(
        [
            "clients-gst-returns",
            {
                limit: pageCount,
                offset: page * pageCount,
                query: {
                    ...filters,
                    labels: filters.labels.map((c: any) => c?.id),
                    sort
                },
                type: 'regular_taxpayer',
                rtntype: 'GSTR1',
                selectedYear: selectedYear,
                selectedMonth,
                category: states?.appliedFilters?.category["value"] === undefined ? [] : [states?.appliedFilters?.category["value"]],
                subCategory: states?.appliedFilters?.subCategory.map((c: any) => c?.value),
                status: states?.appliedFilters?.status["value"] === undefined ? [] : [states?.appliedFilters?.status["value"]],
                jurisdiction: states?.appliedFilters?.jurisdiction["value"] === undefined ? [] : [states?.appliedFilters?.jurisdiction["value"]],
            },
        ],
        getGstrRecords, {
        enabled: !!selectedYear && !!selectedMonth && (permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)),

        onSuccess: (res: any) => {
            setTableData(res?.data?.result)
        },
        onError: (err: any) => {
            if (!err?.error) {
                snack.error(`An error occurred while fetching register data`);
            }
        }
    });
    const [columns, setColumns] = useState(_.cloneDeep(monthLydefaultColumns));
    const handleSort = (v: any) => {
        sortHandler({
            key: v.key,
            columns,
            sortState: sort,
            setSortState: setSort,
            setColumns: setColumns,
        });
    };
    const totalCount = data?.data?.count;
    const { mutate, isLoading: loading } = useMutation(createGstrPromiseClient, {
        onSuccess: (res) => {
            setTimeout(() => {
                queryClient.invalidateQueries("clients-gst-returns");
                setLoad(false);
                snack.success("Sync Successful");
            }, 200);
        },
        onError: (err: any) => {
            snack.error(err.response.data.message);
        },
    });

    const getGstReturnClients = async () => {
        if (!selectedYear) return snack.error('Select Financial Year');
        if (!selectedMonth) return snack.error('Select Month');
        if (!selected.length) return snack.error('Select At least one Client');
        let clientDetails: any = []
        for (let i of selected) {
            if (i?.client?.id) {
                clientDetails.push({ id: i.id, clientId: i.client.id, gstNumber: i.client.gstNumber, returnsData: i.returnsData });
            } else if (i?.clientGroup?.id) {
                clientDetails.push({ id: i.id, clientGroupId: i.clientGroup.id, gstNumber: i.clientGroup.gstNumber, returnsData: i.returnsData });
            }
        }
        let clientDetailss = clientDetails.filter((row: any) => {
            return (!row?.returnsData?.length);
        });
        if (!clientDetailss.length) {
            return snack.error("One-Time Sync! Your GST Returns data has been synced and is ready to use. Since there's no option to revise past GST returns, your data will stay synced.")
        };
        setLoad(true);

        mutate({
            financialYear: selectedYear,
            clientDetails: clientDetailss,
        });
    };

    return (
        <Box >
            <Grid container spacing={2} mb={2} alignItems="center">
                <Grid item xs={6} md={3} order={{ xs: 2, sm: 2, md: 1 }}>
                    <PeriodSelect
                        selectedYear={selectedYear}
                        setSelectedYear={setSelectedYear}
                        selectedMonth={selectedMonth}
                        setSelectedMonth={setSelectedMonth}
                    />
                </Grid>

                <Grid item xs={6} md={4} textAlign={{ xs: "center", md: "right" }} order={3}>
                    <Box display="inline-block">

                        <Button
                            color="secondary"
                            variant="outlined"
                            onClick={() => { getGstReturnClients(); }}
                        >
                            Sync With Portal
                        </Button>

                        <SyncAtomPro selected={selected} />
                    </Box>
                </Grid>
            </Grid>

            <AppliedFilters />
            <Table
                sx={{ mt: 3 }}
                loading={isLoading || lodd}
                data={tableData || []}
                columns={columns}
                sortHandler={handleSort}
                selection={{ selected, setSelected }}
                pagination={{ totalCount, page, setPage, pageCount, setPageCount }}
                heading={RegularTaxHeadings.GSTR1}

            />


        </Box >
    );
}

export default IffTask;
